// API configuration for different environments
const getBaseURL = () => {
  const hostname = window.location.hostname;

  // Check if we're in development environment
  if (
    process.env.NODE_ENV === "development" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {
    // In development, use relative URLs which will be proxied to localhost:5000
    return "";
  }

  // Production environment - use the full URL to app.encodingcareers.com
  // This will work when hosted on quiz.encodingcareers.com
  return "https://app.encodingcareers.com";
};

export const API_BASE_URL = getBaseURL();

// API endpoints
export const API_ENDPOINTS = {
  QUIZ_START: "/quizStart",
  QUIZ_END: "/quizEnd",
  QUIZ_UPDATE: "/quizUpdate",
  SUBMIT_USER: "/submitUser",
};

// Helper function to create full API URL
export const createApiUrl = (endpoint) => {
  const fullUrl = `${API_BASE_URL}${endpoint}`;

  // Debug logging (remove in production if desired)
  if (process.env.NODE_ENV === "development") {
    console.log(`🔗 API Request: ${fullUrl}`);
    console.log(
      `📍 Environment: ${process.env.NODE_ENV}, Host: ${window.location.hostname}`
    );
  }

  return fullUrl;
};
